<div class="aside-menu d-none d-lg-block">
  <div class="card open-bet mb-0 border-0">
      <div class="card-header card-accrdn openbetlist">
        <strong>Open Bets</strong>
      </div>
    </div>
  <div class="card open-bet mb-0 border-0" style="cursor:pointer">
      <div class="card-body open-bet-btns">
        <div class="col-sm-12 p-0 mlist-openbets">
          <!-- <select class="form-select" aria-label="Default select example"  [ngModelOptions]="{standalone: true}" [(ngModel)]="searchMatch" (change)="openBet(searchMatch)">
            <option selected>Select Market</option>
            <option *ngFor="let match of MatchList;let i = index;" value="{{match}}"  ><span >{{match?.match_name}}</span></option>
          </select> -->
          <ng-select [ngModelOptions]="{standalone: true}" [(ngModel)]="searchMatch" aria-label="Default select example" 
                      (change)="openBets(searchMatch)" class="form-select">
                      <ng-option *ngFor="let match of MatchList" [value]="match">{{match.match_name}}</ng-option>
                  </ng-select>
        </div>                        
      </div>
      <div class="col-md-12 p-0" *ngIf="openBetsLength != 0">
        <div class="bet_slip over-wrap racing-tab">
          <div class="matchunmatch-tab tab-container">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="matched1-tab" data-bs-toggle="tab" data-bs-target="#matched1-tab-pane" type="button" role="tab" aria-controls="matched1-tab-pane" aria-selected="true"><span>Matched</span></button>
              </li>
              <!-- <li class="nav-item" role="presentation">
                <button class="nav-link" id="unmatched1-tab" data-bs-toggle="tab" data-bs-target="#unmatched1-tab-pane" type="button" role="tab" aria-controls="unmatched1-tab-pane" aria-selected="false"><span>Unmatched</span></button>
              </li> -->
            </ul>
            <div class="tab-content" id="myTabContent"  *ngIf="betList == true">
              <div class="tab-pane fade show active" id="matched1-tab-pane" role="tabpanel" aria-labelledby="matched1-tab" tabindex="0">
                <div class="slip-list">
                  <ul class="matched-head">
                    <li class="col-bet">Back (Bet For)</li>
                    <li class="col-odd">Odds</li>
                    <li class="col-stake">Stake</li>
                    <li class="col-profit">Profit</li>
                  </ul>
                  <dl  style="display: block;" *ngFor="let bet of backData;let i = index;" [ngClass]="{'slip-lay':bet.is_back == 0,'slip-back':bet.is_back == 1,'showInfo':showBet == 1}" class="">
                    <dd  class="refer refershow" id="betInfo" *ngIf="showBet == 1">
                      <span  id="betId">Ref:{{bet?.bet_id}}</span>
                      <span  id="placeDate">{{bet?.createdAt | date :'dd-MM-yyyy HH:mm:ss'}}</span>
                    </dd>
                    <dt>
                      <span class="slip-type">{{bet.is_back == 0 ? 'Lay' : "Back"}} </span>
                      <span class="short-amount">{{bet?.selection_name}}</span>
                      <span id="marketName" class="short-amount">{{bet?.market_name}}</span>
                    </dt>
                    <dd class="col-odd">{{bet?.odds}}</dd>
                    <dd class="col-stake">{{bet?.stack}}</dd>
                    <dd class="col-profit"><span>{{bet?.p_l | number : '0.0-2'}}</span></dd>
                  </dl>
                  <ul class="matched-head" >
                    <li class="col-bet">Lay (Bet Against)</li>
                    <li class="col-odd">Odds</li>
                    <li class="col-stake">Stake</li>
                    <li class="col-profit">Liability</li>
                  </ul>
                  <dl  style="display: block;" *ngFor="let bet of layData;let i = index;" [ngClass]="{'slip-lay':bet.is_back == 0,'slip-back':bet.is_back == 1,'showInfo':showBet == 1}" class="">
                    <dd  class="refer refershow" id="betInfo" *ngIf="showBet == 1">
                      <span  id="betId">Ref:{{bet?.bet_id}}</span>
                      <span  id="placeDate">{{bet?.createdAt | date :'dd-MM-yyyy HH:mm:ss'}}</span>
                    </dd>
                    <dt>
                      <span class="slip-type">Lay</span>
                      <span class="short-amount">{{bet.is_fancy == 1 ?  (bet?.selection_name) : (bet?.market_name) }}</span>
                      <span id="marketName" class="short-amount">{{bet?.market_name}}</span>
                    </dt>
                    <dd class="col-odd">{{bet?.odds}}</dd>
                    <dd class="col-stake">{{bet?.stack}}</dd>
                    <dd class="col-profit"><span>{{bet?.liability | number : '0.0-2'}}</span></dd>
                  </dl>
                </div>
                <div  class="full_btn">
                  <ul  class="slip-option">
                    <li style="list-style: none !important;">
                      <input  id="showBetInfo" name="openOption" type="checkbox" (click)="showBet == 0 ? showBetHistory(1):showBetHistory(0) "
                        class="ng-valid ng-dirty ng-touched"><label  for="showBetInfo">Bet Info</label></li>
                  </ul>
                </div>
              </div>
              <div class="tab-pane fade" id="unmatched1-tab-pane" role="tabpanel" aria-labelledby="unmatched1-tab" tabindex="0">

              </div>
            </div>                            
          </div>
        </div>
      </div>
    </div>
</div> 